import { render, staticRenderFns } from "./bottledByFor.vue?vue&type=template&id=adcc1ddc&"
import script from "./bottledByFor.vue?vue&type=script&lang=js&"
export * from "./bottledByFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adcc1ddc')) {
      api.createRecord('adcc1ddc', component.options)
    } else {
      api.reload('adcc1ddc', component.options)
    }
    module.hot.accept("./bottledByFor.vue?vue&type=template&id=adcc1ddc&", function () {
      api.rerender('adcc1ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/personalisationOverlay/bottledByFor.vue"
export default component.exports